// 性能
const collectFP = () => {
  return new Promise((resolve) => {
    const entryHandler = (list) => {
      for (const entry of list.getEntries()) {
        if (entry.name === 'first-paint') {
          resolve(entry)
          observer.disconnect()
        }
      }
    }
    const observer = new PerformanceObserver(entryHandler)
    observer.observe({ type: 'paint', buffered: true })
  })
}
// FCP
const collectFCP = () => {
  return new Promise((resolve) => {
    const entryHandler = (list) => {
      for (const entry of list.getEntries()) {
        if (entry.name === 'first-contentful-paint') {
          resolve(entry)
          observer.disconnect()
        }
      }
    }
    const observer = new PerformanceObserver(entryHandler)
    observer.observe({ type: 'paint', buffered: true })
  })
}

const collectLCP = () => {
  return new Promise((resolve) => {
    const entryHandler = (list) => {
      if (observer) {
        observer.disconnect()
      }
      for (const entry of list.getEntries()) {
        resolve(entry)
      }
    }
    const observer = new PerformanceObserver(entryHandler)
    observer.observe({ type: 'largest-contentful-paint', buffered: true })
  })
}

const collectDOMReadyTime = () => {
  return new Promise((resolve) => {
    const callback = () => {
      window.removeEventListener('DOMContentLoaded', callback)
      resolve({
        entryType: 'domReadyTime',
        startTime: performance.now()
      })
    }
    window.addEventListener('DOMContentLoaded', callback)
  })
}

const collectLoadTime = () => {
  return new Promise((resolve) => {
    const callback = () => {
      window.removeEventListener('load', callback, true)
      resolve({
        entryType: 'loadTime',
        startTime: performance.now()
      })
    }
    window.addEventListener('load', callback, true)
  })
}

const collectDNSQueryTime = () => {
  const { domainLookupEnd, domainLookupStart } = window.performance.timing
  return domainLookupEnd - domainLookupStart
}

const collectTCPConnectTime = () => {
  const { connectEnd, connectStart } = window.performance.timing
  return connectEnd - connectStart
}

const collectRequestTime = () => {
  const { responseEnd, requestStart } = window.performance.timing
  return responseEnd - requestStart
}

const collectParseDOMTree = () => {
  const { domComplete, domInteractive } = window.performance.timing
  return domComplete - domInteractive
}

const collectWhiteTime = () => {
  const { domLoading, fetchStart } = window.performance.timing
  return domLoading - fetchStart
}

const collectTiming = () => {
  const timing = performance.timing
  const start = timing.navigationStart
  let dnsTime = 0
  let tcpTime = 0
  let firstPaintTime = 0
  let domRenderTime = 0
  let loadTime = 0

  dnsTime = timing.domainLookupEnd - timing.domainLookupStart
  tcpTime = timing.connectEnd - timing.connectStart
  firstPaintTime = timing.responseStart - start
  domRenderTime = timing.domContentLoadedEventEnd - start
  loadTime = timing.loadEventEnd - start

  return {
    // DNS解析时间
    dnsTime,
    // dnsTime
    tcpTime,
    // n首屏时间
    firstPaintTime,
    // ndom渲染完成时间
    domRenderTime,
    // n页面onload时间
    loadTime
  }
}
export {
  collectFP,
  collectFCP,
  collectLCP,
  collectDNSQueryTime,
  collectTCPConnectTime,
  collectRequestTime,
  collectParseDOMTree,
  collectWhiteTime,
  collectDOMReadyTime,
  collectLoadTime,
  collectTiming
}
